import { withNamespaces } from 'react-i18next';
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Spinner,
} from 'reactstrap';

const MailboxChangeModal = ({
    t,
    isOpen,
    toggle,
    isLoading,
    mailboxChange,
    showMicrosoftReconnectHint,
    onConfirm,
}) => {
    const previousEmail = mailboxChange?.previousEmail || '';
    const newEmail = mailboxChange?.newEmail || '';
    const reused = !!mailboxChange?.reused;
    const warning = mailboxChange?.warning || '';

    return (
        <Modal
            isOpen={isOpen}
            toggle={isLoading ? undefined : toggle}
        >
            <ModalHeader toggle={isLoading ? undefined : toggle}>
                {t('Change email address?')}
            </ModalHeader>
            <ModalBody>
                {reused ? (
                    <p>
                        {t('You are using')}{' '}
                        <strong>{newEmail}</strong>
                        {' '}{t('again')} ({t('was')}{' '}
                        <strong>{previousEmail}</strong>).
                    </p>
                ) : (
                    <p>
                        {t('You are changing the inbox email from')}{' '}
                        <strong>{previousEmail}</strong>
                        {' '}{t('to')}{' '}
                        <strong>{newEmail}</strong>.
                    </p>
                )}

                {warning && (
                    <p className="mb-2">
                        {warning}
                    </p>
                )}

                {reused && (
                    <p className="mb-2">
                        {t('Previous emails for this address will be shown again from SIP.')}
                    </p>
                )}

                {showMicrosoftReconnectHint && (
                    <p className="mb-0">
                        {t('You will need to Connect Microsoft again after this change.')}
                    </p>
                )}
            </ModalBody>
            <ModalFooter>
                <Button
                    type="button"
                    color="secondary"
                    onClick={toggle}
                    disabled={isLoading}
                >
                    {t('Cancel')}
                </Button>
                <Button
                    type="button"
                    color="primary"
                    onClick={onConfirm}
                    disabled={isLoading}
                >
                    {isLoading && (
                        <Spinner size="sm" color="white" className="me-2" />
                    )}
                    {t('Confirm')}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default withNamespaces()(MailboxChangeModal);
